import { createContext } from "react";

export const ClientReportExportContext = createContext({
  handlers: null,
  registerHandlers: () => {},
});
